import axios from "axios";

async function sendGetRequest(path){
    const BackendUrl = localStorage.getItem("backendUrl")
    let token = localStorage.getItem("token");
    let data = (await axios.get(BackendUrl + path, {
        headers: {
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + token
        }
    })).data;
    console.log(data);
    return data;
}

async function sendDeleteRequest(path){
    const BackendUrl = localStorage.getItem("backendUrl")
    let token = localStorage.getItem("token");
    let data = (await axios.delete(BackendUrl + path, {
        headers: {
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + token
        }
    })).data;
    console.log(data);
    return data;
}

async function sendPostRequest(path, payload){
    const BackendUrl = localStorage.getItem("backendUrl")
    let token = localStorage.getItem("token");
    let data = (await axios.post(BackendUrl + path, payload, {
        headers: {
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + token
        }
    })).data;
    console.log(data);
    return data;
}

export async function postLogin(email, password){
    return await sendPostRequest("/login", {email, password});
}

export async function fetchLocations(){
    return await sendGetRequest(`/locations`);
}

export async function fetchWeek(startDate, endDate, type){
    return await sendGetRequest(`/weeks${type}/load?startDate=${startDate}&endDate=${endDate}`);
}

export async function fetchPrograms(startDate, endDate, type){
    return await sendGetRequest(`/programs/week?startDate=${startDate}&endDate=${endDate}&type=${encodeURIComponent(type)}`);
}

export async function postCourseTemp(startDate, endDate, payload){
    return await sendPostRequest(`/coursetemp?startDate=${startDate}&endDate=${endDate}`, payload);
}

export async function postCourse(startDate, endDate, payload){
    return await sendPostRequest(`/courses?startDate=${startDate}&endDate=${endDate}`, payload);
}

export async function postPrograms(startDate, endDate, type, payload){
    return await sendPostRequest(`/programs/week?startDate=${startDate}&endDate=${endDate}&type=${encodeURIComponent(type)}`, payload);
}

export async function getEgo(){
    const BackendUrl = localStorage.getItem("backendUrl")
    //todo use send get Request
    let token = localStorage.getItem("token");
    let user = (await axios.get(BackendUrl + "/user", {
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': 'Bearer ' + token
        }
    })).data;
    console.log(user);
    return user;
}

export async function getUsers(){
    return await sendGetRequest("/users?q=");
}

export async function getUser(id){
    return await sendGetRequest("/users?id=" + id);
}

export async function deleteUser(id){
    return await sendDeleteRequest("/users?id=" + id);
}

export async function addUser(user){
    let tmp = JSON.parse(JSON.stringify(user));
    if(!user.birthday.match("\\d+-\\d+-\\d+")){
        console.log("invalid birthdate");
        setError("Geburtstag ungültig");
        return null;
    }
    tmp.birthday = user.birthday;
    if(!user.email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )){
        console.log("invalid email");
        setError("E-Mail ungültig");
        return null;
    }
    if(!tmp.firstname || !tmp.lastname){
        console.log("need firstname and lastname");
        setError("Vor- oder Nachname ungültig");
        return null;
    }
    if(tmp.contract){
        if(tmp.contract.repeat && !user.contract.startDate?.match("\\d+-\\d+-\\d+")){
            console.log("invalid date contract start");
            setError("Startdatum ungültig");
            return null;
        }
        tmp.contract.startDate = user.contract.startDate;
        if(tmp.contract.repeat && !user.contract.endDate?.match("\\d+-\\d+-\\d+")){
            console.log("invalid date contract end");
            setError("Enddatum ungültig");
            return null;
        }
        tmp.contract.endDate = user.contract.endDate;
        if(!tmp.contract.repeat){
            tmp.contract = null;
        }
    }
    if(!tmp.sex){
        console.log("invalid sex");
        setError("Geschlecht ungültig");
        return null;
    }
    tmp.tickets = parseInt(user.tickets).toString();
    tmp.ticketsMax = parseInt(user.ticketsMax).toString();
    return await sendPostRequest("/users", tmp);
}

export function setError(text){
    let element = document.getElementById("error-message");
    if(element){
        element.innerHTML = text
    }
}